import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/courses/:courseId/exams/interactive/:examId/attempts/:attemptId/submissions`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const interactiveExamSubmissions = {
  post: apiPathFunc(pathBase),
} as const;
